export default "__VITE_ASSET__55bBnjit__"